import WIDGETS from './widgets';

export default {
	name: 'scheduler_chat_message',
	spacing: 2,
	sx: { width: '100%', margin: '0px' },
	widgets: [{ content: WIDGETS.SCHEDULER_CHAT_MESSAGE, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
